;(function() {
  'use strict'

  factory.$inject = ["$log", "userService", "edgeService"];
  angular.module('core.services').factory('MessageComment', factory)

  /* @ngInject */
  function factory($log, userService, edgeService) {
    var user = userService.get()

    function MessageComment(message, options) {
      this.parent = message

      _.defaultsDeep(this, options, this.Defaults)

      if (this.username) {
        this.abbrevName =
          this.username[0].toUpperCase() + this.username[1].toLowerCase()
      }
    }

    MessageComment.prototype.Defaults = {
      text: null,
      username: null,
      userId: null,
      createdAt: moment(),
    }

    MessageComment.prototype.canFlag = function() {
      var loggedIn = !!user.id
      var notHidden = !this.isHidden
      var notCreator = this.userId !== user.id

      return loggedIn && notHidden && notCreator
    }

    MessageComment.prototype.representsElement = function() {
      return _.includes(['subscriber', 'token'], this.creatorType)
    }

    MessageComment.prototype.toggleFlag = function() {
      var self = this

      // halt if cant flag

      if (!this.canFlag()) {
        return
      }

      // disable while loading (boolean is optimistic while loading)

      if (this.userFlagged === true || this.userFlagged === false) {
        return
      }

      // flag

      if (!this.userFlagged) {
        // optimistic

        this.userFlagged = true

        // create edge

        edgeService.create('flag', 'comment', this.id).then(
          function(edgeId) {
            self.userFlagged = edgeId
          },
          function() {
            delete self.userFlagged
          }
        )

        // unflag
      } else {
        // optimistic

        var edgeId = this.userFlagged
        this.userFlagged = false

        // remove edge

        edgeService.remove(edgeId).then(
          function() {
            delete self.userFlagged
          },
          function() {
            self.userFlagged = edgeId
          }
        )
      }
    }

    MessageComment.prototype.fromServer = function(data) {
      // data.token is manually injected by message factory if it exists

      this.id = data.id
      this.isHidden = data.hidden

      this.text = data.content
      this.userId = data.creator.id
      this.creatorType = data.creator.type
      this.createdAt = data.createdAt
      this.userFlagged = data.userFlagged

      this.username = data.creator.name

      // replace email user garbage username
      if (this.creatorType === 'email') {
        var usingEmailToken =
          this.parent.token &&
          this.parent.token === this.parent.emailUserAccessToken
        this.username = usingEmailToken ? 'You' : 'Anonymous'
      }
      // replace subscriber user garbage username
      if (this.creatorType === 'token') {
        var usingAccessToken =
          this.parent.token && this.parent.token === this.parent.accessToken
        this.username = usingAccessToken ? 'You' : this.parent.elementName
      }

      if (this.username) {
        this.abbrevName =
          this.username[0].toUpperCase() + this.username[1].toLowerCase()
      }

      switch (data.creator.type) {
        case 'admin':
          this.tag = 'Glow'
          break
        case 'phone':
          this.tag = 'Creator'
          break
        case 'subscriber':
          this.tag = this.parent.elementName
          break
      }

      if (this.isHidden) {
        this.text = '- Comment removed -'
      }

      return this
    }

    return MessageComment
  }
})()
